import { Checkbox, FormControlLabel, Typography } from '@mui/material'
import { FlexBox } from 'components/atoms'
import { TBet, useBetContext } from 'contexts/BetContext'
import { useTranslation } from 'contexts/TranslationContext'
import { ChangeEvent } from 'react'

export const AllOrdersSelector = ({ bet }: { bet: TBet }) => {
    const { setAllOrders, handleTrackingEvent, mainColor } = useBetContext()
    const translation = useTranslation()

    const handleClick = (e: ChangeEvent<HTMLInputElement>) => {
        const checked = e.target.checked
        setAllOrders(bet.id, checked)
        void handleTrackingEvent({
            eventType: 'ALL_ORDERS',
            actionType: checked ? 'ADD' : 'REMOVE'
        })
    }

    return (
        <FlexBox
            sx={{
                mt: 1,
                width: '100%',
                justifyContent: 'flex-end'
            }}
        >
            <FormControlLabel
                sx={{ mr: 1.5 }}
                control={
                    <Checkbox
                        sx={{ width: 30, height: 30, color: mainColor }}
                        defaultChecked={bet.allOrders}
                        onChange={handleClick}
                    />
                }
                label={
                    <Typography
                        variant="title-14-bold"
                        sx={{ color: '#434B5A', mr: 1 }}
                    >
                        {translation.allOrders}
                    </Typography>
                }
                labelPlacement={'start'}
            />
        </FlexBox>
    )
}
